var PageTop = (function () {
    function PageTop() {
        this.pageTop = document.querySelector('.pagetop');
        this.scroll = window.scrollY;
    }
    PageTop.prototype.showPageTop = function () {
        var _a, _b;
        if ((_a = this.pageTop) === null || _a === void 0 ? void 0 : _a.classList.contains('is-show'))
            return;
        (_b = this.pageTop) === null || _b === void 0 ? void 0 : _b.classList.add('is-show');
    };
    PageTop.prototype.hidePageTop = function () {
        var _a, _b;
        if (!((_a = this.pageTop) === null || _a === void 0 ? void 0 : _a.classList.contains('is-show')))
            return;
        (_b = this.pageTop) === null || _b === void 0 ? void 0 : _b.classList.remove('is-show');
    };
    PageTop.prototype.execute = function () {
        var _this = this;
        var _a;
        window.addEventListener('scroll', function () {
            _this.scroll = window.scrollY;
            if (_this.scroll > 400) {
                _this.showPageTop();
            }
            else {
                _this.hidePageTop();
            }
        });
        (_a = this.pageTop) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    };
    return PageTop;
}());
export default PageTop;
